export const JET_DEPTH = 2;
export const ENEMY_HEALTH_BAR_DEPTH = 3;
export const BULLET_DEPTH = 1;
export const BOUND_MASK = 10;
